
async function refreshCartDrawer2() {
  try {
    // fetch sections + cart in parallel (faster)
    const [sectionsRes, cartRes] = await Promise.all([
      fetch('/?sections=cart-drawer,cart-icon-bubble'),
      fetch('/cart.js')
    ]);

    const data = await sectionsRes.json();
    const cart = await cartRes.json();

    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({
        sections: data,
        id: 'free-gift-update'
      });

      // ✅ EMPTY STATE TOGGLE
      if (cart.item_count === 0) {
        drawer.classList.add('is-empty');
      } else {
        drawer.classList.remove('is-empty');
      }
    }

  } catch (e) {
    console.error('Drawer refresh error:', e);
  }
}
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('#addBtn:not([disabled])');
  if (!btn) return;

  e.preventDefault();
  // 4. Build properties
  const properties = {};

  const nameInput = document.querySelector('#nameInput');
  const nameText = nameInput?.value || '';
  const name = nameText.trim();

  const activeMetal = document.querySelector('button.metal-btn.active');
  const variantId = activeMetal.getAttribute('variant_id');
  const activeFont = document.querySelector('button.font-btn.active');
  const Font = activeFont?.getAttribute('data-font');

  if (Font) properties['Font'] = Font;
  if (name) properties['Name'] = nameText;
  // 5. Build items array
  const items = [
    {
      id: variantId,
      quantity: 1,
      properties: properties
    }
  ];

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    const data = await res.json();
    console.log('Added to cart:', data);

    refreshCartDrawer2();
    document.querySelector('a#cart-icon-bubble')?.click();

  } catch (err) {
    console.error('Error adding to cart:', err);
  }
});



